import { render, staticRenderFns } from "./StripeCheckoutFrame.vue?vue&type=template&id=148a1a36&scoped=true"
import script from "./StripeCheckoutFrame.vue?vue&type=script&lang=js"
export * from "./StripeCheckoutFrame.vue?vue&type=script&lang=js"
import style0 from "./StripeCheckoutFrame.vue?vue&type=style&index=0&id=148a1a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a1a36",
  null
  
)

export default component.exports